import React, { Component } from 'react'
import { getProperty, MEDIA_TYPES } from '../../utils'
import { Loading } from '../../misc'
import {
    formHandler,
    Button,
    Select,
    TextInput,
} from '../../ui'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gearActions from '../../../actions/gear'

class WirelessSystemSelectionForm extends Component {
    constructor(props) {
        super(props)

        this.state = { data: this.props.data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (! this._getWirelessSystemTypes().length) {
            this.props.gearActions.loadWirelessSystemTypes(this.props.type)
        }
        if (! this._getWirelessSystemMakes().length) {
            this.props.gearActions.loadWirelessSystemMakes(this.props.type)
        }

        // it's possible we already have the data on load so never need to load it in, as such,
        // we should check it in cWM as well as in cWRP
        this._detectWirelessTypeAutoset(this.props)
    }

    componentWillReceiveProps(nextProps) {
        // when we get the wireless_system_types, see if there's only 1 in there. If so, we hardcode
        // the value to that value
        this._detectWirelessTypeAutoset(nextProps)
    }

    _detectWirelessTypeAutoset(props) {
        if (getProperty(props.gear, `wireless_system_types.${ props.type }`, []).length === 1) {
            this._updateValue({ wireless_type: props.gear.wireless_system_types[props.type][0].value })
        }
    }

    _getWirelessSystemTypes() {
        return getProperty(this.props.gear, `wireless_system_types.${ this.props.type }`, [])
    }

    _getWirelessSystemMakes() {
        return getProperty(this.props.gear, `wireless_system_makes.${ this.props.type }`, [])
    }

    _submitWirelessSystemData = () => {
        const data = {
            media_type: MEDIA_TYPES[this.props.type],
            wireless_type: this.state.data.wireless_type,
            make: this.state.data.make,
            model: this.state.data.model,
            number: this.state.data.number,
        }

        this.props.gearActions.submitWirelessSystem(
            this.props.type,
            data,
            this.props.crew_uuid,
            this.state.data.uuid
        )
    }

    render() {
        if (! this._getWirelessSystemTypes().length) {
            return <Loading />
        }
        if (! this._getWirelessSystemMakes().length) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let typeField = null

        if (this._getWirelessSystemTypes().length > 1) {
            typeField = (
                <Select
                    error={ errors.wireless_type }
                    name="wireless_type"
                    options={ this._getWirelessSystemTypes() }
                    placeholder="Select type"
                    updateValue={ this._updateValue }
                    value={ this.state.data.wireless_type }
                />
            )
        }

        return (
            <div>
                { typeField }
                <Select
                    error={ errors.make }
                    name="make"
                    options={ this._getWirelessSystemMakes() }
                    placeholder="Select make"
                    updateValue={ this._updateValue }
                    value={ this.state.data.make }
                />
                <TextInput
                    error={ errors.model }
                    name="model"
                    placeholder="Enter model"
                    updateValue={ this._updateValue }
                    value={ this.state.data.model }
                />
                <TextInput
                    error={ errors.number }
                    name="number"
                    placeholder="Enter total number of this wireless system owned"
                    type="number"
                    updateValue={ this._updateValue }
                    value={ this.state.data.number }
                />

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitWirelessSystemData }
                    status="primary"
                >
                    Save
                </Button>
            </div>
        )
    }
}

WirelessSystemSelectionForm.propTypes = {
    appState: React.PropTypes.object.isRequired,
    crew_uuid: React.PropTypes.string.isRequired,
    data: React.PropTypes.object.isRequired,
    gear: React.PropTypes.object.isRequired,
    gearActions: React.PropTypes.object.isRequired,
    type: React.PropTypes.oneOf([ 'audio', 'video' ]).isRequired,
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            gear: state.gear,
        }
    },
    (dispatch) => {
        return {
            gearActions: bindActionCreators(gearActions, dispatch),
        }
    }
)(WirelessSystemSelectionForm)



// WEBPACK FOOTER //
// ./app/components/gear/modals/wireless_system_selection_form.js